import ToolMenuCategory from '@/components/Layouts/Default/Partials/Navbar/ToolMenuCategory';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { MENU } from '@/features/tool/data';

const ToolMenu = ({
  isDashboardLink = false,
  isFooter = false,
}: {
  isDashboardLink?: boolean;
  isFooter?: boolean;
}) => {
  const t = useTranslations();
  const menuData = MENU(t);

  return (
    <div
      className={clsx(
        'grid grid-cols-1 xs:grid-cols-2 p-4 sm:grid-cols-3 md:p-4 lg:grid-cols-6 gap-6',
        isDashboardLink && '!grid-cols-1'
      )}
    >
      <div className="flex flex-col gap-8">
        <ToolMenuCategory
          data={menuData[0]}
          isFooter={isFooter}
          isDashboard={isDashboardLink}
        />

        <ToolMenuCategory
          data={menuData[1]}
          isFooter={isFooter}
          isDashboard={isDashboardLink}
        />

        <ToolMenuCategory
          data={menuData[2]}
          isFooter={isFooter}
          isDashboard={isDashboardLink}
        />
      </div>

      <div>
        <ToolMenuCategory
          data={menuData[3]}
          isFooter={isFooter}
          isDashboard={isDashboardLink}
        />
      </div>

      <div>
        <ToolMenuCategory
          data={menuData[4]}
          isFooter={isFooter}
          isDashboard={isDashboardLink}
        />
      </div>

      <div>
        <ToolMenuCategory
          data={menuData[5]}
          isFooter={isFooter}
          isDashboard={isDashboardLink}
        />
      </div>

      <div>
        <ToolMenuCategory
          data={menuData[6]}
          isFooter={isFooter}
          isDashboard={isDashboardLink}
        />
      </div>

      <div className="flex flex-col gap-8">
        <ToolMenuCategory
          data={menuData[7]}
          isFooter={isFooter}
          isDashboard={isDashboardLink}
        />

        <ToolMenuCategory
          data={menuData[8]}
          isFooter={isFooter}
          isDashboard={isDashboardLink}
        />
      </div>
    </div>
  );
};

export default ToolMenu;
